var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuryportal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H2C0.9 0 0 0.9 0 2V15C0 16.1 0.9 17 2 17H20C21.1 17 22 16.1 22 15V2C22 0.9 21.1 0 20 0ZM2 15V2H10V15H2ZM20 15H12V2H20V15ZM13 5.5H19V7H13V5.5ZM13 8H19V9.5H13V8ZM13 10.5H19V12H13V10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuryportal);
export default __webpack_public_path__ + "static/media/juryportal.8b2d34ddaeaa46718a0f451db7e5768b.svg";
export { ForwardRef as ReactComponent };